export const SHORTEST_MONTH_LENGTH = 28;

export const MODE = {
  today: 'today',
  sevenDays: '7days',
  thirtyDays: '30days',
  isoWeek: 'isoWeek',
  month: 'month',
  year: 'year',
};

export const RANGE_MODE = [
  MODE.today,
  MODE.sevenDays,
  MODE.thirtyDays,
  MODE.isoWeek,
  MODE.month,
  MODE.year,
];

export const PERIOD_CONST = { monthly: 'monthly', daily: 'daily' };
